<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().active" (change)="onActiveToggle($event)">
        Active
    </mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().pendingActive" (change)="onPendingActiveToggle($event)">
        Pending Active
    </mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().onboardingInProgress" (change)="onOnboardingInProgressToggle($event)">
        Onboarding In Progress
    </mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().pendingInactive" (change)="onPendingInactiveToggle($event)">
        Pending Inactive
    </mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().inactive" (change)="onInactiveToggle($event)">
        Inactive
    </mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().terminated" (change)="onTerminatedToggle($event)">
        Terminated
    </mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().deleted" (change)="onDeletedToggle($event)">
        Deleted
    </mat-slide-toggle>
</div>
<div class="d-flex flex-column status-toggle">
    <mat-slide-toggle [checked]="getStateService().staging" (change)="onStagingToggle($event)">
        Staging
    </mat-slide-toggle>
</div>

<ng-container *ngIf="getStateService().allStatusFiltersDisabled()">
    <div class="mt-2">
        <span style="color: red">*</span>&nbsp;<span class="text-muted">All filters inactive, <br />no partner organizations will be displayed</span>
    </div>
</ng-container>